<script setup>
import { IconMenu2, IconX, IconFolder, IconLogout } from '@tabler/icons-vue'
import { BadgeComponent } from '@claitontech/chap-lib'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useThemeStore } from '@/stores/theme'
import { useAuthStore } from '@/stores/auth'
import { useRoute, useRouter } from 'vue-router'

const { t } = useI18n()
const themeStore = useThemeStore()
const authStore = useAuthStore()
const route = useRoute()
const router = useRouter()

const isNavbarCollapsed = ref(false)
const isLeasing = computed(() => route.params.company === 'leasing')

const toggleNavbar = () => {
  isNavbarCollapsed.value = !isNavbarCollapsed.value
}

const handleLogout = () => {
  authStore.logout()
  router.push({ name: 'login', params: { company: route.params.company } })
}
</script>
<template>
  <header class="navbar navbar-expand-md d-print-none">
    <div class="container-xl">
      <button
        class="navbar-toggler"
        type="button"
        aria-controls="navbar-menu"
        :aria-expanded="isNavbarCollapsed"
        aria-label="Toggle navigation"
        @click="toggleNavbar"
      >
        <IconMenu2 v-if="!isNavbarCollapsed" stroke="2" class="icon" />
        <IconX v-else stroke="2" class="icon" />
      </button>
      <h1
        v-if="themeStore.currentCompany"
        class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3"
      >
        <router-link
          v-if="route.params.company"
          :to="{ name: 'company-cases', params: { company: route.params.company } }"
        >
          <img
            v-if="themeStore.currentTheme.logo"
            :src="themeStore.currentTheme.logo"
            :alt="themeStore.currentTheme.name"
            class="navbar-brand-image"
          />
          <span v-else class="navbar-brand-text">{{ themeStore.currentTheme.name }}</span>
        </router-link>
        <BadgeComponent v-if="isLeasing" variant="primary" class="ms-2" text="Leasing" />
      </h1>
      <div
        :class="[
          'navbar-collapse justify-content-md-center',
          isNavbarCollapsed ? 'collapsed' : 'collapse',
        ]"
        id="navbar-menu"
      >
        <div
          class="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center"
        >
          <ul class="navbar-nav" v-if="authStore.isLoggedIn">
            <li v-if="route.params.company" class="nav-item">
              <router-link
                :to="{ name: 'company-cases', params: { company: route.params.company } }"
                class="nav-link"
                @click="isNavbarCollapsed = false"
              >
                <span class="nav-link-icon d-md-none d-lg-inline-block">
                  <IconFolder :size="24" />
                </span>
                <span class="nav-link-title">
                  {{ t('views.cases.pageTitle') }}
                </span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="authStore.isLoggedIn" class="navbar-nav flex-row order-md-last">
        <button
          class="btn btn-ghost-secondary"
          @click="handleLogout"
          :title="t('common.logout')"
          :aria-label="t('common.logout')"
        >
          <IconLogout :size="20" stroke="2" />
        </button>
      </div>
    </div>
  </header>
</template>
